import { useEffect } from "react";
import { IZipCode } from "../interfaces/api/IUtilsCommons.interface";
import { useApi } from "./useApi";
import { useRedux } from "./useRedux";
import UtilsCommonsService from "../services/utilsCommons.service";

const { getZipCode } = new UtilsCommonsService();

export function useZipCode({ postalCode }: { postalCode: number }) {
  const {
    data: {
      clientPersist: { uuid },
    },
  } = useRedux();
  const {
    data: dataGetZipCode = [],
    error: errorZipCode,
    execute: executeGetZipCode,
    isLoading: isLoadingGetZipCode,
  } = useApi<IZipCode[], { zipCode: number; processId: string }>(getZipCode);

  useEffect(() => {
    if (postalCode) {
      executeGetZipCode({ zipCode: postalCode, processId: uuid });
    }
  }, [postalCode]);

  return {
    dataGetZipCode,
    isLoadingGetZipCode,
    errorZipCode,
  };
}
